module.exports = __webpack_public_path__ + "static/thumbnail_logo_skeleton-1accd8663133c7a0e5e5c92a9c8746d6.png";